/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Callback_CrumbInputs */

const en_auth_callback_crumb = /** @type {(inputs: Auth_Callback_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in`)
};

const pl_auth_callback_crumb = /** @type {(inputs: Auth_Callback_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie`)
};

/**
* | output |
* | --- |
* | "Signing in" |
*
* @param {Auth_Callback_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_callback_crumb = /** @type {((inputs?: Auth_Callback_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Callback_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_callback_crumb(inputs)
	return en_auth_callback_crumb(inputs)
});